export { default as DevelopmentCAD } from './page'


// WEBPACK FOOTER //
// ./src/pages/developmentCAD/index.js